module.exports = __webpack_public_path__ + "img/welcome_section.704751a6.png";